import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { message } from 'antd'
import ReactDOM from 'react-dom'
import {
  Div, Icon, H3, P, H1,
} from 'konsys-ui'
import { LoginModal } from '../../pages/login'
import history from '../../history'
import {
  MenuWrapper, MenuListWrapper, LinkBox, LogoWrapper, MenuMobile,
  FooterWrapper, FooterTitle, QrcodeImage, ContainerWrapper, LinkBoxContainer,
  HeaderWrapper, LinkDiv, FooterIcon, FooterLink,
} from './styled'
import Logo from '../../images/logo/Boxsuit-Logo-02.png'
import QrCode from '../../images/footer/qr-code.png'
import PATH from '../../constants/path'
import { theme, screenSize } from '../../styles/_variables'
import { getAccessToken, removeAccessToken } from '../../utils/local-data-service'
import EmailIcon from '../../images/footer/Email_Icon.png'
import FbIcon from '../../images/footer/Facebook_Contact_Icon.png'
import IgIcon from '../../images/footer/Instagram_Icon.png'
import LineIcon from '../../images/footer/Line_Chat_Icon.png'
import PhoneIcon from '../../images/footer/Phone_Icon.png'
import WebIcon from '../../images/footer/Website_Icon.png'

const menuColor = '#808181'

export class LoginRender extends React.PureComponent {
  constructor(props) {
    super(props)
    this.el = document.createElement('div')
    this.el.className = `container-modal ${props.class} login`
  }

  componentDidMount() {
    document.getElementById('root').appendChild(this.el)
  }

  componentDidUpdate() {
    this.el.className = `container-modal ${this.props.class} login`
  }

  render() {
    return ReactDOM.createPortal(
      <LoginModal
        hideLogin={() => this.props.hideModal()}
      />,
      this.el,
    )
  }
}

export const Header = ({ isShowModal }) => {
  const [windowSize, setWindowSize] = useState(window.innerWidth)
  const [menuActive, setMenuActive] = useState(false)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowSize(window.innerWidth)
    })
  })

  return (
    <MenuWrapper>
      <LoginRender class={showModal ? 'modal-active' : 'modal-hide'} hideModal={() => {
        setShowModal(false)
        isShowModal(false)
      }} />
      <Div cursor='pointer' display='inline-flex' alignItems='center'>
        <LogoWrapper onClick={() => { history.push(PATH.home) }} src={Logo} />
      </Div>
      {
        windowSize <= screenSize.tablet
          ? <MenuMobile active={menuActive}>
            <Icon style={{ cursor: 'pointer' }} color={menuColor} icon='far fa-bars' onClick={() => setMenuActive(!menuActive)} />
            <MenuListWrapper>
              <LinkBox color={menuColor} exact to={PATH.home} activeClassName='active'>HOME</LinkBox>
              <LinkBox color={menuColor} to={PATH.packaging} activeClassName='active'>PACKAGING<span>CATALOG</span></LinkBox>
              <LinkBox color={menuColor} to={PATH.information} activeClassName='active'>PRINTING<span>INFORMATION</span></LinkBox>
              <LinkBox color={menuColor} to={PATH.gallery} activeClassName='active'>GALLERY</LinkBox>
              <LinkBox color={menuColor} to={PATH.payment} activeClassName='active'>PAYMENT<span>VERIFICATION</span></LinkBox>
              {
                getAccessToken()
                  ? <LinkBox
                    activeClassName='active'
                    color={menuColor}
                    to={PATH.member}
                  >MY ACCOUNT</LinkBox>
                  : <LinkDiv
                    as='div'
                    onClick={() => {
                      setShowModal(true)
                      isShowModal(true)
                    }}
                    color={menuColor}
                  >SIGN IN / SIGN UP</LinkDiv>
              }
              {
                getAccessToken()
                && <LinkDiv
                  color={menuColor}
                  as='div'
                  onClick={() => {
                    removeAccessToken()
                    message.success('ออกจากระบบเรียบร้อย')
                    setTimeout(() => {
                      window.location = PATH.home
                    }, 1000)
                  }}
                >LOG OUT</LinkDiv>
              }
            </MenuListWrapper>
          </MenuMobile>
          : <MenuListWrapper>
            <LinkBox color={menuColor} exact to={PATH.home} activeClassName='active'>HOME</LinkBox>
            <LinkBox color={menuColor} to={PATH.packaging} activeClassName='active'>PACKAGING<span>CATALOG</span></LinkBox>
            <LinkBox color={menuColor} to={PATH.information} activeClassName='active'>PRINTING<span>INFORMATION</span></LinkBox>
            <LinkBox color={menuColor} to={PATH.gallery} activeClassName='active'>GALLERY</LinkBox>
            <LinkBox color={menuColor} to={PATH.payment} activeClassName='active'>PAYMENT<span>VERIFICATION</span></LinkBox>
            {
              getAccessToken()
                ? <LinkBoxContainer
                  activeClassName='active'
                  to={PATH.member}
                ><Icon fontSize={theme.fonts.size.subTitle} color={menuColor} icon='fal fa-user-circle' /></LinkBoxContainer>
                : <LinkDiv
                  as='div'
                  onClick={() => {
                    setShowModal(true)
                    isShowModal(true)
                  }}
                >
                  <Icon fontSize={theme.fonts.size.subTitle} color={menuColor} icon='fal fa-user-circle' />
                </LinkDiv>
            }
          </MenuListWrapper>
      }
    </MenuWrapper>
  )
}

export const Footer = () => (
  <FooterWrapper>
    <FooterTitle>
      <H3 color={theme.color.offWhite}>ติดต่อเรา</H3>
      <Div>
        <P color={theme.color.offWhite} display='block' margin='24px 0 32px'>วันทำการ : จันทร์ - เสาร์ (ยกเว้นวันหยุดนักขัตฤกษ์)<br/>ช่วงเวลาทำการ : 8.00 - 18.00 น.</P>
        <Div display='flex'>
          <Div>
            <P color={theme.color.offWhite} display='block' margin='12px 0'><FooterIcon src={PhoneIcon} />082-362-6146</P>
            <P color={theme.color.offWhite} display='block' margin='12px 0'><FooterIcon src={EmailIcon} />contactus@boxsuit.in.th</P>
            <P color={theme.color.offWhite} display='block' margin='12px 0'><FooterIcon src={WebIcon} />www.boxsuit.in.th</P>
            <P color={theme.color.offWhite} display='block' margin='12px 0'><FooterIcon src={FbIcon} />boxsuit</P>
            <P color={theme.color.offWhite} display='block' margin='12px 0'><FooterIcon src={IgIcon} />@boxsuit</P>
          </Div>
          <Div margin='0 0 0 100px'>
            <P color={theme.color.offWhite} display='block' margin='12px 0'><FooterIcon src={LineIcon} />@boxsuit</P>
            <a href='http://nav.cx/jfELBYg' target='_blank' rel="noopener noreferrer">
              <QrcodeImage src={QrCode} />
            </a>
          </Div>
        </Div>
      </Div>
    </FooterTitle>
    <FooterTitle>
      <H3 color={theme.color.offWhite}>เมนู</H3>
      <Div className='menu-list' display='flex' margin='10px 0 0 48px'>
        <Div>
          <FooterLink to={PATH.home}>
            <P color={theme.color.offWhite} display='block' margin='12px 0'>หน้าแรก</P>
          </FooterLink>
          <FooterLink to={PATH.packaging}>
              <P color={theme.color.offWhite} display='block' margin='12px 0'>รายการบรรจุภัณฑ์</P>
            </FooterLink>
          <FooterLink to={PATH.information}>
            <P color={theme.color.offWhite} display='block' margin='12px 0'>ตัวเลือกเทคนิคงานพิมพ์</P>
          </FooterLink>
          </Div>
          <Div margin='0 0 0 60px'>
            <FooterLink to={PATH.gallery}>
            <P color={theme.color.offWhite} display='block' margin='12px 0'>ผลงานของเรา</P>
          </FooterLink>
            <FooterLink to={PATH.request}>
              <P color={theme.color.offWhite} display='block' margin='12px 0'>ขอใบเสนอราคา</P>
            </FooterLink>
            <FooterLink to={PATH.payment}>
              <P color={theme.color.offWhite} display='block' margin='12px 0'>ยืนยันการชำระเงิน</P>
            </FooterLink>
        </Div>
      </Div>
    </FooterTitle>
  </FooterWrapper>
)

const Container = ({
  header,
  children,
  blur,
  isHome,
  backgroundColor,
}) => {
  const [isShowModal, setIsShowModal] = useState(false)
  useEffect(() => {
    if (!_.isUndefined(blur)) {
      setIsShowModal(blur)
    }
  })
  return (
    <ContainerWrapper
      id='container'
      blur={isShowModal}
      isHome={isHome}
      backgroundColor={backgroundColor}
    >
      {
        header.type === 'title'
        && <HeaderWrapper bgImg={header.img}>
          <Div display='inline-block' maxWidth={theme.maxWidth}>
            <Header isShowModal={value => setIsShowModal(value)} />
            <H1 display='block' margin='120px 0 0' color={header.color ? header.color : theme.color.offWhite}>{header.title}</H1>
          </Div>
        </HeaderWrapper>
      }
      { children }
      <Footer />
    </ContainerWrapper>
  )
}

export const ContainerWithoutHeader = ({ children, isHome, blur }) => (
  <ContainerWrapper blur={blur} isHome={isHome}>
    {
      children
    }
    <Footer />
  </ContainerWrapper>
)

export default Container



// WEBPACK FOOTER //
// ./src/components/container/index.jsx